<template>
    <div style="height: 100%; padding-bottom: 18px">
        <div class="sa-accordion-wrapper">
            <form>
                <div v-if="showRsaPrescrizioneTabFarmaci" class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-farmaco-radio-a" value="1" checked="checked" />
                    <label class="sa-accordion-label" for="prescrizione-farmaco-radio-a">
                        Farmaci
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPrescrizioneFarmacologica()">
                            <i class="fas fa-plus"></i>
                            Nuova Prescrizione
                        </b-button>
                        <b-form-checkbox class="pull-right sa-accordion-btn" v-model="mostraTutte" size="lg" switch>
                            <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px">Mostra tutte</span>
                        </b-form-checkbox>
                        <b-form-checkbox class="pull-right sa-accordion-btn" v-model="raggruppa" size="lg" switch>
                            <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px"> Raggruppa</span>
                        </b-form-checkbox>

                        <!--- <b-button size="sm" variant="outline-purple outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickStampa()">
              <b-icon icon="printer" />
              Stampa
            </b-button>-->
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <template v-if="raggruppa">
                                <template v-if="this.prescrizioniFarmacologiche.length > 0">
                                    <div v-for="(listaFarmaci, nomeGruppo, indexGruppo) in getFarmaciRaggruppati" :key="nomeGruppo" class="mb-4">
                                        <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-' + indexGruppo" style="cursor: pointer">
                                            <div>
                                                <i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                            </div>

                                            <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                        </div>

                                        <b-collapse :id="'collapse-gruppo-' + indexGruppo" visible>
                                            <div class="sa-card-list">
                                                <div v-for="(item, index) in listaFarmaci" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.statoAttuale) }" :class="getClass('card', item.statoAttuale)">
                                                    <b-row align-v="center" class="m-0 py-3">
                                                        <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                                            <!-- <div class="sa-ft-label-pai">{{ item.tipoPrestazione }}

                                                            </div> -->
                                                            <div class="sa-ft-valore-pai primary-text">
                                                                <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                            <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                            <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                <div v-html="item.note"></div>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="1" class="mb-2 mb-md-0">
                                                            <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                                            <div class="sa-ft-valore-pai text-muted small">
                                                                {{ item.programmazione }}
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="6" md="2" class="mb-2 mb-md-0 text-center align-content-center">
                                                            <div class="sa-ft-label-pai">STATO</div>
                                                            <div class="mt-1">
                                                                <span class="sa-ft-badge" :class="getClass('stato', item.statoAttuale)">
                                                                    {{ item.statoAttuale }}
                                                                </span>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="6" md="1" class="mb-2 mb-md-0 align-content-center">
                                                            <div class="sa-ft-label-pai">INIZIO / FINE</div>
                                                            <div class="sa-ft-valore-pai small">
                                                                <div>Inizio: {{ formatDate(item.dataInizio) }}</div>
                                                                <div v-if="item.dataFine">Fine: {{ formatDate(item.dataFine) }}</div>
                                                                <div v-else class="text-muted">Fine: --</div>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="1" class="text-right mt-3 mt-md-0">
                                                            <div class="d-flex justify-content-md-end ft-gap-8-px">
                                                                <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Modifica Pianificazione" @click="onClickEditPrescrizioneFarmacologica(item, index, $event.target)" class="rounded-circle sa-ft-floating-btn primary">
                                                                    <b-icon icon="pencil"></b-icon>
                                                                </b-button>

                                                                <b-button size="sm" v-b-tooltip.hover title="Concludi/Sospendi" variant="outline-purple" @click="onClickCambioStato(item, index, $event.target)" class="rounded-circle sa-ft-floating-btn warning">
                                                                    <i class="fas fa-exchange-alt"></i>
                                                                </b-button>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </template>
                                <template v-else>
                                    <NoDataComponent ref="cmpNoDataComponent" title="Non sono presenti prescrizioni" nome="no-data" subtitle="" icon="fas fa-capsules" />
                                </template>
                            </template>
                            <template v-else>
                                <b-table sticky-header ref="table" stacked="lg" striped hover :items="elencoFarmaci" :fields="fieldsPrescrizioniFarmacologiche" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                    <template #cell(index)="row">
                                        <span> {{ row.index + 1 }} </span>
                                    </template>
                                    <template v-slot:cell(prescrizione)="{ item }">
                                        <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                    </template>
                                    <template v-slot:cell(note)="{ item }">
                                        <span v-html="item.note"></span>
                                    </template>
                                    <template v-slot:cell(dataInizio)="{ item }">
                                        <span style="display: inline-block; white-space: nowrap">Inizio: {{ formatDate(item.dataInizio) }}</span
                                        ><br />
                                        <span style="display: inline-block; white-space: nowrap">Fine: {{ formatDate(item.dataFine) }}</span>
                                    </template>
                                    <template v-slot:cell(actions)="row">
                                        <b-container class="bv-example-row">
                                            <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizioneFarmacologica(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                <b-icon icon="pencil"></b-icon>
                                            </b-button>
                                            <b-button size="sm" v-b-tooltip.hover title="Concludi/Sospendi" variant="outline-purple sa-margin-left float-sm-left" @click="onClickCambioStato(row.item, row.index, $event.target)"><i class="fas fa-exchange-alt"></i> </b-button>
                                        </b-container>
                                    </template>
                                </b-table>
                            </template>
                        </div>
                    </div>
                </div>
                <div v-if="showRsaPrescrizioneTabPrestazioni" class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-prestazione-radio-a" value="2" />
                    <label class="sa-accordion-label" for="prescrizione-prestazione-radio-a">
                        Prestazioni
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPrescrizionePrestazione()">
                            <i class="fas fa-plus"></i>
                            Prescrivi Prestazione
                        </b-button>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="prescrizioniPrestazioni" :fields="fieldsPrescrizioniPrestazioni" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizionePrestazioni(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
                <div v-if="showRsaPrescrizioneTabEsercizi" class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-esercizi-radio-a" value="3" />
                    <label class="sa-accordion-label" for="prescrizione-esercizi-radio-a">
                        Esercizi
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPrescrizioneEsercizi()"> <i class="fas fa-plus"></i> Nuova Prescrizione </b-button>
                        <b-form-checkbox class="pull-right sa-accordion-btn" v-model="mostraTutteEsercizi" size="lg" switch>
                            <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px">Mostra tutte</span>
                        </b-form-checkbox>
                        <b-form-checkbox class="pull-right sa-accordion-btn" v-model="raggruppaEsercizi" size="lg" switch>
                            <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px"> Raggruppa</span>
                        </b-form-checkbox>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <template v-if="raggruppaEsercizi">
                                <template v-if="prescrizioniEsercizi.length > 0">
                                    <div v-for="(listaEsercizi, nomeGruppo, indexGruppo) in getEserciziRaggruppati" :key="nomeGruppo" class="mb-4">
                                        <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-esercizi-' + indexGruppo" style="cursor: pointer">
                                            <div>
                                                <!-- Ho cambiato l'icona in una più adatta agli esercizi, come un manubrio -->
                                                <i class="fas fa-dumbbell" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                            </div>
                                            <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                        </div>

                                        <b-collapse :id="'collapse-gruppo-esercizi-' + indexGruppo" visible>
                                            <div class="sa-card-list">
                                                <div v-for="(item, index) in listaEsercizi" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.statoAttuale) }" :class="getClass('card', item.statoAttuale)">
                                                    <b-row align-v="center" class="m-0 py-3">
                                                        <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                                            <div class="sa-ft-valore-pai primary-text">
                                                                <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                            <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                            <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                <div v-html="item.note"></div>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="1" class="mb-2 mb-md-0">
                                                            <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                                            <div class="sa-ft-valore-pai text-muted small">
                                                                {{ item.programmazione }}
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="6" md="2" class="mb-2 mb-md-0 text-center align-content-center">
                                                            <div class="sa-ft-label-pai">STATO</div>
                                                            <div class="mt-1">
                                                                <span class="sa-ft-badge" :class="getClass('stato', item.statoAttuale)">
                                                                    {{ item.statoAttuale }}
                                                                </span>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="6" md="1" class="mb-2 mb-md-0 align-content-center">
                                                            <div class="sa-ft-label-pai">INIZIO / FINE</div>
                                                            <div class="sa-ft-valore-pai small">
                                                                <div>Inizio: {{ formatDate(item.dataInizio) }}</div>
                                                                <div v-if="item.dataFine">Fine: {{ formatDate(item.dataFine) }}</div>
                                                                <div v-else class="text-muted">Fine: --</div>
                                                            </div>
                                                        </b-col>

                                                        <b-col cols="12" md="1" class="text-right mt-3 mt-md-0">
                                                            <div class="d-flex justify-content-md-end ft-gap-8-px">
                                                                <div class="sa-print-button-wrapper">
                                                                    <print-component :linkPrintData="getLinkPrintPrescrizione(item)" :typeButton="'small'" :nomeFile="'prescrizione_esercizi'" />
                                                                </div>
                                                                <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Modifica Pianificazione" @click="onClickEditPrescrizioneEsercizi(item, index, $event.target)" class="rounded-circle sa-ft-floating-btn primary">
                                                                    <b-icon icon="pencil"></b-icon>
                                                                </b-button>
                                                                <b-button size="sm" v-b-tooltip.hover title="Concludi/Sospendi" variant="outline-purple" @click="onClickCambioStato(item, index, $event.target)" class="rounded-circle sa-ft-floating-btn warning">
                                                                    <i class="fas fa-exchange-alt"></i>
                                                                </b-button>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </template>
                                <template v-else>
                                    <NoDataComponent ref="cmpNoDataComponentEsercizi" title="Non sono presenti esercizi prescelti" nome="no-data" subtitle="" icon="fas fa-dumbbell" />
                                </template>
                            </template>
                            <template v-else>
                                <b-table sticky-header ref="tableEsercizi" stacked="lg" striped hover :items="elencoEsercizi" :fields="fieldsPrescrizioniEsercizi" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                    <template #cell(index)="row">
                                        <span> {{ row.index + 1 }} </span>
                                    </template>
                                    <template v-slot:cell(prescrizione)="{ item }">
                                        <span v-html="getTestoHtmlNomeAttivita(item)"></span>
                                    </template>
                                    <template v-slot:cell(note)="{ item }">
                                        <span v-html="item.note"></span>
                                    </template>
                                    <template v-slot:cell(dataInizio)="{ item }">
                                        <span style="display: inline-block; white-space: nowrap">Inizio: {{ formatDate(item.dataInizio) }}</span
                                        ><br />
                                        <span style="display: inline-block; white-space: nowrap">Fine: {{ formatDate(item.dataFine) }}</span>
                                    </template>
                                    <template v-slot:cell(actions)="row">
                                        <b-container class="bv-example-row">
                                            <div class="sa-print-button-wrapper">
                                                <print-component :linkPrintData="getLinkPrintPrescrizione(item)" :typeButton="'small'" :nomeFile="'prescrizione_esercizi'" />
                                            </div>
                                            <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizioneEsercizi(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                <b-icon icon="pencil"></b-icon>
                                            </b-button>
                                            <b-button size="sm" v-b-tooltip.hover title="Concludi/Sospendi" variant="outline-purple sa-margin-left float-sm-left" @click="onClickCambioStato(row.item, row.index, $event.target)"><i class="fas fa-exchange-alt"></i> </b-button>
                                        </b-container>
                                    </template>
                                </b-table>
                            </template>
                        </div>
                    </div>
                </div>
                <!-- <div class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-esercizi-radio-a" value="3" />
                    <label class="sa-accordion-label" for="prescrizione-esercizi-radio-a">
                        Esercizi
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="noClickNuovaPrescrizioneEsercizi()">
                            <i class="fas fa-plus"></i>
                            Prescrivi Esercizi
                        </b-button>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="prescrizioniEsercizi" :fields="fieldsPrescrizioniEsercizi" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizionePrestazioni(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div> -->
            </form>
        </div>
        <sa-modal-loading ref="saModalLoading" />
        <b-modal ref="cmpPrint" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <div class="text-center">
                <b-spinner style="width: 3rem; height: 3rem" label="Large Spinner" variant="info"></b-spinner>
            </div>
            <p class="my-4" style="text-align: center">Generazione Stampa in corso...</p>
        </b-modal>

        <b-modal ref="mdlStampaPrescrizione" size="xl" scrollable>
            <iframe title="Anteprima prescrizione" :src="stampaPrescrizioneReport" width="100%" height="600px"></iframe>
        </b-modal>

        <!-- <print-component v-show="false" ref="cmpPrint" :reportName="reportName" :printData="printData"></print-component> -->

        <rsa-paziente-prescrizione-farmaci-edit-modal-component ref="mdlRsaPazientePrescrizioneFarmaciEditModalComponent" @afterSave="onAfterSaveRsaPazientePrescrizioneFarmaciEditModalComponent"></rsa-paziente-prescrizione-farmaci-edit-modal-component>
        <rsa-paziente-prescrizione-farmaco-edit-modal-component ref="mdlRsaPazientePrescrizioneFarmacoEditModalComponent" @afterSave="onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent" @afterCloseModal="onAfterCloseModalPrescrizioniEdit"></rsa-paziente-prescrizione-farmaco-edit-modal-component>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <prescrizione-farmaco-component ref="mdlPrescrizioneFarmacoComponent" @afterSava="onAfterSaveMdlPrescrizioneFarmacoComponent"></prescrizione-farmaco-component>
        <prescrizione-specialistica-component ref="mdlPrescrizioneSpecialisticaComponent" @afterSava="onAfterSaveMdlPrescrizioneSpecialisticaComponent"></prescrizione-specialistica-component>
        <rsa-prescrizioni-cambio-stato-modal-component ref="cmpPrescrizioniCambioStato" @cambioStatoSuccess="onCambioStatoSuccess"></rsa-prescrizioni-cambio-stato-modal-component>
    </div>
</template>

<script>
import moment from "moment";
import RsaAreePianificazioneEditComponent from "../RsaAreePianificazioneEditComponent.vue";
import RsaPazientePrescrizioneFarmacoEditModalComponent from "../../../rsapaziente/components/RsaPazientePrescrizioneFarmacoEditModalComponent.vue";
import PrescrizioneFarmacoComponent from "../../../../utility/components/PrescrizioneFarmacoComponent.vue";
import PrescrizioneSpecialisticaComponent from "../../../../utility/components/PrescrizioneSpecialisticaComponent.vue";
import axios from "axios";
import NoDataComponent from "../../../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../../../utility/UtilityMixin";
import { SaModalLoading } from "../../../../../template/components/modal";
import RsaPrescrizioniCambioStatoModalComponent from "./RsaPrescrizioniCambioStatoModalComponent.vue";
import RsaPazientePrescrizioneFarmaciEditModalComponent from "../../../rsapaziente/components/RsaPazientePrescrizioneFarmaciEditModalComponent.vue";
import PrintComponent from "../../../../utility/components/PrintComponent.vue";
// import PrintComponent from "../../../../utility/components/PrintComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { NoDataComponent, RsaPrescrizioniCambioStatoModalComponent, RsaAreePianificazioneEditComponent, RsaPazientePrescrizioneFarmacoEditModalComponent, PrescrizioneFarmacoComponent, PrescrizioneSpecialisticaComponent, SaModalLoading, RsaPazientePrescrizioneFarmaciEditModalComponent, PrintComponent },
    data() {
        return {
            mostraTutte: false,
            perPage: 10000,
            pathResource: "/rsapazienteprescrizioni",
            pathResourcePazientePrescrizioniFarmacologiche: "/rsapazienteprescrizioni/farmaci",
            pathResourcePazientePrescrizioniEsercizi: "/rsapazienteprescrizioni/esercizi",
            pathResourcePazientePrescrizioniPrestazioni: "/rsapazienteprescrizioni/prestazioni",
            stampaPrescrizioneReport: null,
            linkStampa: "/print/createreport",
            pathResourcesAree: "/rsaaree",
            prescrizioniFarmacologiche: [],
            prescrizioniPrestazioni: [],
            prescrizioniEsercizi: [],
            jsonDataAccettazione: null,
            viaSomministrazioneOptions: [],
            showRsaPrescrizioneTabFarmaci: true,
            showRsaPrescrizioneTabPrestazioni: true,
            showRsaPrescrizioneTabEsercizi: true,
            area: null,
            raggruppa: true,
            mostraTutteEsercizi: false,
            raggruppaEsercizi: true,
            fieldsPrescrizioniFarmacologiche: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    // thStyle: "width: 50rem",
                    sortable: true,
                },
                {
                    label: "Programmazione",
                    key: "programmazione",
                    thStyle: "width: 5rem",
                    sortable: false,
                },
                // {
                // 	label: "Orari",
                // 	key: "programmazioneOrariDescrizioni",
                // 	thStyle: "width: 10rem",
                // 	sortable: true,
                // },
                {
                    label: "Indicazioni",
                    key: "note",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: false,
                },
                {
                    label: "Inizio/Fine",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsPrescrizioniPrestazioni: [
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    sortable: true,
                },
                {
                    label: "Q.tà",
                    key: "quantita",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Orari",
                    key: "frequenza",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Posologia",
                    key: "posologia",
                    thStyle: "width: 8rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                    thStyle: "width: 5rem",
                    //tdClass: "text-right",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsPrescrizioniEsercizi: [
                {
                    label: "Esercizi",
                    key: "prescrizione",
                    sortable: true,
                },
                {
                    label: "Q.tà",
                    key: "quantita",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Orari",
                    key: "frequenza",
                    thStyle: "width: 3rem",
                    sortable: true,
                },
                {
                    label: "Posologia",
                    key: "posologia",
                    thStyle: "width: 8rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                    thStyle: "width: 5rem",
                    //tdClass: "text-right",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        this.loadAree();
        this.loadModalitaSomministrazione();
    },
    computed: {
        elencoFarmaci() {
            return this.mostraTutte ? this.prescrizioniFarmacologiche : this.prescrizioniFarmacologiche.filter((e) => e.statoAttuale != "CONCLUSA");
        },
        getFarmaciRaggruppati() {
            const somministrazioneOrder = [...this.viaSomministrazioneOptions].sort((a, b) => {
                return (a.ordering || 0) - (b.ordering || 0);
            });
            const temp = {};
            const farmaciAlBisogno = [];
            this.elencoFarmaci.forEach((farmaco) => {
                if (farmaco.alBisogno) {
                    farmaciAlBisogno.push(farmaco);
                } else {
                    const via = farmaco.viaSomministrazione;
                    if (!temp[via]) {
                        temp[via] = [];
                    }
                    temp[via].push(farmaco);
                }
            });
            const returnValue = {};

            somministrazioneOrder.forEach((element) => {
                const via = element.nome;
                if (temp[via]) {
                    returnValue[via] = temp[via];
                }
            });
            if (farmaciAlBisogno.length > 0) {
                returnValue["alBisogno"] = farmaciAlBisogno;
            }

            return returnValue;
        },

        elencoEsercizi() {
            return this.mostraTutteEsercizi ? this.prescrizioniEsercizi : this.prescrizioniEsercizi.filter((e) => e.statoAttuale != "CONCLUSA");
        },

        getEserciziRaggruppati() {
            const temp = {};
            const eserciziAlBisogno = [];

            this.elencoEsercizi.forEach((item) => {
                if (item.alBisogno) {
                    eserciziAlBisogno.push(item);
                } else {
                    const gruppo = item.viaSomministrazione || "Altro";
                    if (!temp[gruppo]) temp[gruppo] = [];
                    temp[gruppo].push(item);
                }
            });

            if (eserciziAlBisogno.length > 0) {
                temp["alBisogno"] = eserciziAlBisogno;
            }

            return temp;
        },
    },
    methods: {
        getClass(sezione, valore) {
            switch (sezione) {
                case "stato":
                    if (valore == "IN CORSO") {
                        return "sa-ft-badge-blue";
                    } else if (valore == "PROGRAMMATA") {
                        return "sa-ft-badge-default";
                    } else {
                        return "sa-ft-badge-red";
                    }
                case "card":
                    if (valore == "IN CORSO") {
                        return "sa-ft-badge-blue";
                    } else if (valore == "PROGRAMMATA") {
                        return "sa-ft-badge-default";
                    } else {
                        return "sa-ft-badge-red";
                    }
                default:
                    break;
            }
        },
        loadModalitaSomministrazione() {
            let link = process.env.VUE_APP_PATH_API + "/rsapazienteprescrizionimodalitasomministrazione";
            axios
                .get(link)
                .then((response) => {
                    this.viaSomministrazioneOptions = response.data.data.list;
                })
                .catch(() => {});
        },
        getTestoHtmlNomeAttivita(prescrizione) {
            let returnValue = prescrizione.prescrizione;
            if (prescrizione.tipo === "SOLUZIONE" || prescrizione.tipo === "ELASTOMERO" || prescrizione.tipo === "ATTIVITA FISICA") {
                if (prescrizione.params != "{}") {
                    let params = JSON.parse(prescrizione.params);
                    returnValue += `<br/>Durata: <b>${params.durata}</b> <br />`;
                }
            }
            returnValue += `Via Somministrazione: <b>${prescrizione.viaSomministrazione}</b>`;

            return returnValue;
        },

        getPrescrizioneHtml(prescrizione) {
            let htmlContent = "";
            let prescrizioneHtml = prescrizione.split(/\\n/g);
            prescrizioneHtml.forEach((element, index) => {
                if (index === 0) {
                    htmlContent += "<p><strong>" + element + "</strong></p><ul>";
                } else if (index === prescrizioneHtml.length - 1) {
                    htmlContent += "<li>" + element + "</li>" + "</ul>";
                } else {
                    htmlContent += "<li>" + element + "</li>";
                }
            });

            return htmlContent;
        },
        loadAree() {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAree + "/codicearea/SMT";
            axios
                .get(link)
                .then((response) => {
                    me.area = response.data.data;
                })
                .catch(() => {});
        },
        loadPrescrizioniPaziente(jsonDataAccettazione) {
            let me = this;
            me.showRsaPrescrizioneTabFarmaci = this.appConfig.showRsaPrescrizioneTabFarmaci;
            me.showRsaPrescrizioneTabPrestazioni = this.appConfig.showRsaPrescrizioneTabPrestazioni;
            me.showRsaPrescrizioneTabEsercizi = this.appConfig.showRsaPrescrizioneTabEsercizi;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.loadPrescrizioniFarmacologichePaziente();
            me.loadPrescrizioniPrestazioniPaziente();
            me.loadPrescrizioniEserciziPaziente();
        },
        loadPrescrizioniFarmacologichePaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniFarmacologiche;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniFarmacologiche = [];
                    me.prescrizioniFarmacologiche = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        loadPrescrizioniEserciziPaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniEsercizi;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniEsercizi = [];
                    me.prescrizioniEsercizi = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        loadPrescrizioniPrestazioniPaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniPrestazioni;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniPrestazioni = [];
                    me.prescrizioniPrestazioni = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        onClickNuovaPrescrizioneEsercizi() {
            let prescrizione = {
                idAccettazione: this.jsonDataAccettazione.id,
                idPaziente: this.jsonDataAccettazione.id,
                dataInizio: new Date().getTime(),
                dataFine: null,
                alBisogno: false,
                salvavita: false,
                obbligoNota: false,
                misuraPressione: false,
                misuraGlicemia: false,
                modificabile: false,
                caricoPaziente: false,
                terapiaPsichiatrica: false,
                note: null,
                tipoPrestazione: "RIABILITAZIONE MOTORIA",
                tipo: null,
                programmazioneTipo: null,
                programmazioneGiorni: null,
                programmazioneOrari: null,
                programmazioneTipologia: null,
                prescrizioneFarmaci: [],
                listaEsercizi: [],
            };
            this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show(prescrizione, this.jsonDataAccettazione);
        },
        onClickNuovaPrescrizioneFarmacologica() {
            let prescrizione = {
                idAccettazione: this.jsonDataAccettazione.id,
                idPaziente: this.jsonDataAccettazione.id,
                dataInizio: new Date().getTime(),
                dataFine: null,
                alBisogno: false,
                salvavita: false,
                obbligoNota: false,
                misuraPressione: false,
                misuraGlicemia: false,
                modificabile: false,
                caricoPaziente: false,
                terapiaPsichiatrica: false,
                note: null,
                tipoPrestazione: "FARMACOLOGICA",
                tipo: null,
                programmazioneTipo: null,
                programmazioneGiorni: null,
                programmazioneOrari: null,
                programmazioneTipologia: null,
                prescrizioneFarmaci: [],
                listaEsercizi: [],
            };
            this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show(prescrizione, this.jsonDataAccettazione);
            // let prescrisione = {
            //   id: null,
            //   idAccettazione: this.jsonDataAccettazione.id,
            //   idPaziente: this.jsonDataAccettazione.id,
            //   dataInizio: new Date().getTime(),
            //   dataFine: null,
            //   codiceProdotto: null,
            //   atcGmp: null,
            //   prescrizione: null,
            //   quantita: 0,
            //   frequenza: null,
            //   costo: 0,
            //   stato: null,
            //   note: null,
            //   tipoPrestazione: "FARMACOLOGICA",
            //   params: JSON.stringify({ formaFarmaceutica: null, listaOrari: [] }),
            // };
            // if (this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
            //   let messaggio = this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
            //   this.$bvModal.msgBoxOk(messaggio, {
            //     title: "ATTENZIONE",
            //     size: "sm",
            //     okVariant: "outline-danger",
            //     headerClass: "sa-msg-header-danger",
            //     footerClass: "p-2 border-top-0",
            //     centered: true,
            //   });
            //   return;
            // } else {
            //   this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, prescrisione);
            // }
        },

        onClickEditPrescrizioneFarmacologica(prescrizione) {
            this.loadEditData(prescrizione.id);
            //this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, prescrizione);
        },
        onClickEditPrescrizioneEsercizi(prescrizione) {
            this.loadEditData(prescrizione.id);
        },
        onClickNuovaPrescrizionePrestazione() {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" || me.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                this.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else {
                me.$refs.mdlPrescrizioneSpecialisticaComponent.show(me.jsonDataAccettazione);
            }
        },
        onClickEditPrescrizionePrestazioni(item) {
            let me = this;
            me.$refs.mdlPrescrizioneSpecialisticaComponent.edit(me.jsonDataAccettazione, item);
        },
        loadEditData(id) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + id, {}, me.loadEditDataSuccess, me.loadEditDataError);
        },

        loadEditDataSuccess(response) {
            this.$refs.mdlRsaPazientePrescrizioneFarmaciEditModalComponent.show(response.data.data, this.jsonDataAccettazione);
        },

        loadEditDataError(response) {
            console.log(response);
        },

        onAfterSaveMdlPrescrizioneFarmacoComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onAfterSaveMdlPrescrizioneSpecialisticaComponent() {
            let me = this;
            me.loadPrescrizioniPrestazioniPaziente();
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() {},

        onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onClickCambioStato(item) {
            let me = this;
            me.$refs.cmpPrescrizioniCambioStato.show(item);
        },
        onCambioStatoSuccess() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
            me.loadPrescrizioniPrestazioniPaziente();
        },
        onAfterCloseModalPrescrizioniEdit() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onAfterSaveRsaPazientePrescrizioneFarmaciEditModalComponent(data) {
            let me = this;
            if (data.tipoPrestazione == "RIABILITAZIONE MOTORIA") {
                me.loadPrescrizioniEserciziPaziente();
            } else {
                me.loadPrescrizioniFarmacologichePaziente();
            }
        },
        onClickStampa() {
            let me = this;
            me.$refs.cmpPrint.onPrint();
        },
        getLinkPrintPrescrizione(item) {
            return "/rsapazienteprescrizioni/printdata/" + item.id + "?idAccettazione=" + this.jsonDataAccettazione.id;
        },
    },
};
</script>

<style scoped>
.sa-card-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 8px;
}

/* La Card Moderna */
.sa-ft-modern-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    position: relative;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), border-color 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    z-index: 1;
}

.sa-ft-modern-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
    z-index: 10;
}

.sa-ft-modern-card:hover {
    transform: translateY(-5px);
    border-color: var(--hover-color);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1), 0 4px 8px var(--hover-color);
    z-index: 10;
}

.sa-ft-modern-card.status-programmata::before {
    background-color: #28a745;
    /* Verde */
}

.sa-ft-modern-card.status-in-corso::before {
    background-color: #007bff;
    /* Blu */
}

.sa-ft-icona-collapse {
    transition: transform 0.5s ease-in-out;
    color: #6c757d;
    font-size: 14px;
}

/* Quando BootstrapVue chiude il pannello, aggiunge la classe .collapsed al toggle */
.sa-utility-section.collapsed .sa-ft-icona-collapse {
    transform: rotate(180deg);
}

/* Effetto hover */
.sa-utility-section:hover .sa-ft-icona-collapse {
    color: var(--bg-sidebar);
}

/* Tipografia */
.sa-ft-label-pai {
    font-size: 0.65rem;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.sa-ft-valore-pai {
    font-size: 0.9rem;
    color: #333;
}

.sa-ft-valore-pai.primary-text {
    color: #0056b3;
    font-weight: 600;
}

/* Badge Arrotondati */
.sa-ft-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    display: inline-block;
    border: 1px solid #dee2e6;
    max-width: fit-content;
}

.sa-ft-badge-blue {
    background-color: #e8f0fe;
    color: #1a73e8;
    border-left: 3px solid #1a73e8 !important;
    border: 1px solid #1a73e8;
}

.sa-ft-badge-green-water {
    background-color: #e8f0fe;
    color: #1ae8c6;
    border-left: 3px solid #1ae8c6 !important;
    border: 1px solid #1ae8c6;
}

.sa-ft-badge-default {
    background-color: #f8f9fa;
    color: #666;
    border-left: 3px solid #666 !important;
    border: 1px solid #666;
}

.sa-ft-badge-red {
    background-color: #f8f9fa;
    color: #b42e2ec7;
    border-left: 3px solid #b42e2ec7 !important;
    border: 1px solid #b42e2ec7;
}

.sa-ft-badge-green {
    background-color: #f8f9fa;
    color: #28a745;
    border-left: 3px solid #28a745 !important;
    border: 1px solid #28a745;
}

.ft-gap-8-px {
    gap: 8px;
}
.sa-print-button-wrapper >>> button {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 0 !important;

    background-color: transparent !important;
    color: #6f42c1 !important;
    border: 1px solid #6f42c1 !important;

    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease, color 0.25s ease !important;
}

.sa-print-button-wrapper >>> button:hover {
    transform: translateY(-2px) !important;
    background-color: #6f42c1 !important;
    color: #fff !important;
    box-shadow: 0 6px 12px rgba(111, 66, 193, 0.25) !important;
}

.sa-print-button-wrapper >>> button svg {
    margin: 0 !important;
}
</style>
